// @flow
import React from 'react'
import { Link } from 'react-router'
import styled from 'styled-components'

const NavLink = styled(Link)`
  &.active {
    font-weight: bold;
  }
`

const AdminNav = () => (
  <ul>
    <li>
      <NavLink to="/admin" activeClassName="active" onlyActiveOnIndex>
        Users
      </NavLink>
    </li>
    <li>
      <NavLink to="/admin/clients" activeClassName="active">
        Clients
      </NavLink>
    </li>
    <li>
      <NavLink to="/admin/newsletter" activeClassName="active">
        Newsletter
      </NavLink>
    </li>
  </ul>
)

export default AdminNav



// WEBPACK FOOTER //
// ./src/components/AdminNav/index.js